(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/hooks/use-loader.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/hooks/use-loader.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect;
const useLoader = (ref, loading) => {
  useEffect(() => {
    let loader;
    if (loading) {
      loader = new svs.ui.Loader(ref.current).show(300, 'inverted');
    }
    return () => {
      var _loader;
      (_loader = loader) === null || _loader === void 0 || _loader.hide(true);
    };
  }, [ref, loading]);
};
svs.kenoXpress.react.hooks.useLoader = useLoader;

 })(window);